import { useState } from "react";
import axios from "axios";
import { Loader2, Search, X } from "lucide-react";

const PlacesAutocomplete = ({ onSelect }) => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSuggestions = async (input) => {
    if (!input.trim()) return setSuggestions([]);
    setLoading(true);

    try {
      const response = await axios.post(
        "https://places.googleapis.com/v1/places:autocomplete",
        {
          input, // what user typed
          languageCode: "en",
          regionCode: "IN", // restrict to India
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Goog-Api-Key": process.env.REACT_APP_GOOGLE_MAP_KEY,
            "X-Goog-FieldMask":
              "suggestions.placePrediction.placeId,suggestions.placePrediction.text",
          },
        }
      );

      const preds = response.data.suggestions || [];
      // console.log("preds,", preds);
      setSuggestions(preds);
    } catch (err) {
      console.error("Autocomplete error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async (placeId, text) => {
    setQuery(text);
    setSuggestions([]);

    try {
      const { data } = await axios.get(
        `https://places.googleapis.com/v1/places/${placeId}`,
        {
          params: {
            key: process.env.REACT_APP_GOOGLE_MAP_KEY,
          },
          headers: {
            "X-Goog-FieldMask":
              "id,displayName,formattedAddress,location,plusCode,addressComponents",
          },
        }
      );

      const place = data;
      onSelect(place);
    } catch (err) {
      console.error("Place details fetch error:", err);
    }
  };
  
  const handleClear = () => {
    setQuery("");
    setSuggestions([]);
  };

  return (
    <div className="relative w-full">
      <input
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          fetchSuggestions(e.target.value);
        }}
        placeholder="Search for area, street or landmark..."
        className="w-full border border-gray-300 rounded-md p-3 text-sm  focus:outline-none"
      />

      <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer">
        {loading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : query ? (
          <X
            className="w-4 h-4 hover:text-primary transition"
            onClick={handleClear}
          />
        ) : (
          <span className="text-gray-400 text-xs select-none">
            <Search className="w-4 h-4 transition" />
          </span>
        )}
      </div>

      {suggestions.length > 0 && (
        <ul className="absolute mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-64 overflow-y-auto z-[9999]">
          {suggestions.map((s, idx) => {
            const { placePrediction } = s;
            return (
              <li
                key={idx}
                onClick={() =>
                  handleSelect(
                    placePrediction.placeId,
                    placePrediction.text.text
                  )
                }
                className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
              >
                {placePrediction.text.text}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default PlacesAutocomplete;
